import React from 'react';
import styled from 'styled-components';
import {StyledTypography} from '../Sdk.styles';

export interface ReleaseNotesSectionProps {
    title?: string;
}

export const RELEASE_NOTES_SECTION_ID = 'release-notes-section';

const Section = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const Divider = styled.hr`
    width: 100%;
    margin-top: 68px;
    margin-bottom: 40px;
    border: 1px solid rgba(255, 255, 255, 0.2);
`;

const ReleaseNotesSection: React.FC<ReleaseNotesSectionProps> = props => {
    if (!props) return null;

    return (
        <Section id={RELEASE_NOTES_SECTION_ID}>
            <Divider />
            <StyledTypography fontSize={36} fontWeight={600} lineHeight={61} customColor="#FFF" textAlign="center">
                {props.title}
            </StyledTypography>
        </Section>
    );
};

export default ReleaseNotesSection;
